<template>
  <HModal
    :show-close="false"
    visible
    :mask="false"
  >
    <div class="duba-tips">
      <h5 class="title">
        {{ title }}
      </h5>
      <p class="content">
        {{ content }}
      </p>
      <div class="btn-w">
        <a
          href="javascript:;"
          class="cancle-btn"
          @click="handleCancle"
        >取消</a>
        <a
          href="javascript:;"
          class="submit-btn"
          @click="handleSubmit"
        >安装</a>
      </div>
    </div>
  </HModal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '驱动精灵会员-提示'
    },
    content: String
  },
  methods: {
    handleCancle () {
      this.$emit('cancle')
    },
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>
<style lang="scss" scoped>
.duba-tips {
  width: 400px;
  height: 180px;
  background: url(~@/assets/images/tips-bg.png) no-repeat center center;
  font-size: 12px;
  position: fixed;
  z-index: 1111;
  left: 50%;
  top: 50%;
  margin-left: -200px;
  margin-top: -90px;
  .title {
    height: 28px;
    line-height: 28px;
    padding-left: 28px;
    color: #A77727;
    font-weight: normal;
  }
  .content {
    font-size: 14px;
    color: #656D77;
    line-height:24px;
    padding: 30px 30px 0 41px;
  }
}
.btn-w {
  text-align: right;
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.cancle-btn {
  color: #5C5C5C;
  text-decoration: underline;
  margin-right: 20px;
}
.submit-btn {
  color: #fff;
  width: 90px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  background: #76BD44;
  border-radius: 2px;
  display: inline-block;
}
</style>
